export const cmsAssistantSearchReportListUrl = () =>
	"api/v1/cmsAssistant/searchReports/list";

export const cmsAssistantSearchReportExportUrl = () =>
	"api/v1/cmsAssistant/searchReports/export";

export const CMS_ASSISTANT_SEARCH_REPORTS = [
	{ reportKey: "searchTerms", name: "Search terms", path: "/reports/searchTerms" },
	{ reportKey: "zeroKeywordResults", name: "Zero keyword results", path: "/reports/zeroKeywordResults" },
	{ reportKey: "zeroSessionsNoAi", name: "Zero sessions (no AI)", path: "/reports/zeroSessionsNoAi" },
	{ reportKey: "aiOverviews", name: "AI overviews", path: "/reports/aiOverviews" },
	{ reportKey: "resultsClicked", name: "Results clicked", path: "/reports/resultsClicked" },
	{ reportKey: "aiCitationsClicked", name: "AI citation clicks", path: "/reports/aiCitationsClicked" },
	{ reportKey: "topAiCitations", name: "Top AI citations", path: "/reports/topAiCitations" },
];
